import { render, staticRenderFns } from "./MemberArticle.vue?vue&type=template&id=c95f2526&"
import script from "./MemberArticle.vue?vue&type=script&lang=js&"
export * from "./MemberArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports